import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MetricScoreGroup, MetricScore } from 'src/app/services/metric-scores.service';
import { Observable } from 'rxjs';

@Component({
  selector: '[app-scoring-row]',
  templateUrl: './scoring-row.component.html',
  styleUrls: ['./scoring-row.component.scss']
})
export class ScoringRowComponent implements OnInit {

  @Input() metricScoreGroup: MetricScoreGroup;
  @Input() rankingStatus: string;
  @Input() saveScoresEvent: Observable<boolean>;

  @Output() outputEvent = new EventEmitter<MetricScore>();

  constructor() { }

  ngOnInit() { }

  sendOutput($event) {
    this.outputEvent.emit($event);
  }

}
